type BulkActionPartialError = { data?: { added?: number } };

export const getBulkProcessedCount = (error?: BulkActionPartialError): number | undefined => {
    const processedCount = error?.data?.added;
    const hasProcessedAny = typeof processedCount === 'number' && processedCount > 0;

    return hasProcessedAny ? processedCount : undefined;
};
